import styled from 'styled-components'

type GradientTextProps = {
  gradient?: string
}

export const GradientText = styled.span<GradientTextProps>`
  background: ${({ gradient, theme }) =>
    gradient ||
    `linear-gradient(to right, ${theme.palette.giphyLightBlue}, ${theme.palette.giphyAqua})`};
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  margin: 2px 0;
`
